import { render } from "./PlusIcon.vue?vue&type=template&id=11407552&scoped=true"
const script = {}

import "./PlusIcon.vue?vue&type=style&index=0&id=11407552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11407552"]])

export default __exports__